module.exports = __webpack_public_path__ + "static/media/elegant-thumbnail1.2b23e296.png";